/**
 * Export `apiEndpoints` config.
 */

export const apiEndpoints = {
  appsCryptoProviders: '/apps/crypto/providers',
  appsCryptoOverview: '/apps/crypto/overview',
  appsCryptoTransactions: '/apps/crypto/transactions',
  appsCryptoDeleteTransaction: '/apps/crypto/transactions/${id}',
  appsCryptoTrades: '/apps/crypto/trades',
  appsCryptoTradeAdd: '/apps/crypto/trades',
  appsCryptoTradeEdit: '/apps/crypto/trades/${id}',
  appsCryptoTradeDelete: '/apps/crypto/trades/${id}',
  appsCryptoTradeAddTransaction: '/apps/crypto/trades/${tradeId}/manage-trade/${type}/${transactionId}',
  cryptoAccounts: '/crypto/accounts',
  cryptoWallets: '/crypto/wallets',
  cryptoOverview: '/crypto/overview',
  cryptoAssets: '/crypto/assets',
  dashboardOverview: '/dashboard/overview',
  categories: '/lists/categories',
  categoriesAdd: '/lists/categories',
  categoriesDelete: '/lists/categories/${id}',
  subCategoriesDelete: '/lists/sub-categories/${id}',
  subCategories: '/lists/sub-categories',
  subCategoriesAdd: '/lists/sub-categories',
  budgets: '/lists/budgets',
  budgetsById: 'lists/budgets/${id}',
  budgetsAdd: '/lists/budgets',
  budgetsDelete: 'lists/budgets/${id}',
  budgetsEdit: 'lists/budgets/${id}',
  bankAccount: '/lists/bank-accounts',
  bankAccountGet: '/lists/bank-accounts/${id}',
  bankList: '/bank-accounts/bank-list',
  bankAccountRefresh: '/lists/bank-accounts/${id}/refresh',
  bankAccountRecalculateBalances: '/lists/bank-accounts/recalculate-balances',
  bankAccountAdd: '/lists/bank-accounts',
  bankAccountDelete: '/lists/bank-accounts/${id}',
  bankAccountConnectGet: '/bank-accounts/connect/${country}',
  bankAccountConnectRebuild: '/bank-accounts/connect/${accountId}/rebuild',
  bankAccountCleanTransactions: '/bank-accounts/connect/${accountId}/clean-transactions',
  bankAccountConnectRedirectUrl: '/bank-accounts/connect/redirect-url',
  bankAccountConnectLocalConnection: '/bank-accounts/connect/local',
  bankAccountConnectDeleteConnection: '/bank-accounts/connect/delete/${bankAccount}',
  bankAccountConnectDeleteAccount: '/bank-accounts/account/delete/${integrationId}',
  bankAccountConnectLinks: '/bank-accounts/connect/sync-accounts',
  bankAccountConnectStatus: '/bank-accounts/connect/sync-accounts/status/${integrationId}',
  bankAccountConnectFirstRefreshTransactions: '/bank-accounts/connect/${accountId}/sync/${referenceId}/transactions',
  coins: 'lists/coins',
  transactions: '/transactions',
  transactionBadges: '/lists/transaction-badges',
  transactionBadgesById: '/lists/transaction-badges/${id}',
  transactionBadgeAttach: '/transactions/${id}/badges/${badgeId}',
  transactionsByRange: '/transactions/range',
  transactionsFiltersYear: '/transactions/filters/year',
  transactionsFiltersMonth: '/transactions/filters/months',
  transactionsAdd: '/transactions',
  transactionsBulkCategory: '/transactions/bulk-category',
  transactionsEdit: '/transactions/${id}',
  transactionById: '/transactions/${id}',
  transactionsSimilar: '/transactions/${id}/similar',
  transactionsRepositionCandidates: '/transactions/${id}/reposition-candidates',
  transactionsBulkRepositionCandidates: '/transactions/${id}/bulk-reposition-candidates',
  movementShares: '/movement-shares',
  movementShareDelete: '/movement-shares/${id}',
  publicMovementShare: '/public/movement-shares/${token}',
  loginGoogle: '/auth/google',
  login: '/auth/login',
  register: '/auth/register',
  verifyEmail: '/auth/verify',
  resendVerification: '/auth/verify/resend',
  forgotPassword: '/auth/password/forgot',
  resetPassword: '/auth/password/reset',
  logout: '/auth/logout',
  healthStatus: '/health/status',
  me: '/me',
  updateProfile: '/me',
  updatePassword: '/me/password',
  adminUsers: '/admin/users',
  adminUserById: '/admin/users/${id}',
  adminUserPassword: '/admin/users/${id}/password',
  adminUserImpersonate: '/admin/users/${id}/impersonate',
  adminFeatureFlags: '/admin/feature-flags',
  adminFeatureFlagByKey: '/admin/feature-flags/${key}',
  stopImpersonating: '/me/stop-impersonating',
  movementsOverview: '/movements/overview',
  backup: '/backup/database',
  restore: '/restore/database',
  projects: '/projects',
  projectsAdd: '/projects',
  projectById: '/projects/${id}',
  projectSuppliers: '/projects/${projectId}/suppliers',
  projectProposals: '/projects/${projectId}/proposals',
  projectMovements: '/projects/${projectId}/movements',
  projectMovementById: '/projects/${projectId}/movements/${id}',
  projectOverview: '/projects/${projectId}/overview',
  projectProposalsById: '/projects/${projectId}/proposals/${proposalId}',
  projectProposalsByIds: '/projects/${projectId}/proposals-ids',
  projectSuppliersContacts: '/projects/${projectId}/suppliers/${supplierId}/contacts',
  projectBudgets: '/projects/${projectId}/budgets',
  projectPaymentTypes: '/projects/${projectId}/payment-types',
  projectShares: '/projects/${projectId}/shares',
  projectShareById: '/projects/${projectId}/shares/${id}',
  usersSearch: '/users/search',
  uploadImage: '/upload',
  appsNotes: '/apps/notes/files',
  appsNotesById: '/apps/notes/files/${id}',
  appsNotesTrash: '/apps/notes/trash',
  appsNotesSearch: '/apps/notes/search',
  appsNotesRestore: '/apps/notes/files/${id}/restore',
  appsNotesPurge: '/apps/notes/files/${id}/purge',
  appsNotesLinks: '/apps/notes/links',
  appsNotesLinkById: '/apps/notes/links/${id}',
  appsNotesBacklinks: '/apps/notes/files/${id}/backlinks',
  cryptoGestChains: '/apps/crypto-gest/chains',
  cryptoGestOverview: '/apps/crypto-gest/overview',
  cryptoGestValueHistory: '/apps/crypto-gest/value-history',
  cryptoGestTransactions: '/apps/crypto-gest/transactions',
  cryptoGestSettings: '/apps/crypto-gest/settings',
  cryptoGestRates: '/apps/crypto-gest/rates',
  cryptoGestFx: '/apps/crypto-gest/fx',
  cryptoGestAsset: '/apps/crypto-gest/assets/${assetId}',
  cryptoGestAssetTransactions: '/apps/crypto-gest/assets/${assetId}/transactions',
  cryptoGestAssetRewardRun: '/apps/crypto-gest/assets/${assetId}/reward-run',
  cryptoGestAssetPriceHistory: '/apps/crypto-gest/assets/${assetId}/price-history',
  cryptoGestWallets: '/apps/crypto-gest/wallets',
  cryptoGestWalletsSyncAll: '/apps/crypto-gest/wallets/sync-all',
  cryptoGestWalletById: '/apps/crypto-gest/wallets/${id}',
  cryptoGestWalletSync: '/apps/crypto-gest/wallets/${id}/sync',
  cryptoGestWalletEntries: '/apps/crypto-gest/wallets/${id}/entries',
  cryptoGestWalletNexoImport: '/apps/crypto-gest/wallets/${id}/nexo-import',
  cryptoGestTransferMatches: '/apps/crypto-gest/transfer-matches',
  cryptoGestWalletOnchainTx: '/apps/crypto-gest/wallets/${id}/onchain-tx',
  cryptoGestOnchainTxCreateEntry: '/apps/crypto-gest/wallets/${id}/onchain-tx/${txId}/create-entry',
  cryptoGestEntryById: '/apps/crypto-gest/wallets/${id}/entries/${entryId}',
  cryptoGestAssetLogo: '/apps/crypto-gest/logos/${symbol}',
  cryptoGestAdminStablecoins: '/admin/crypto-gest/stablecoins',
  cryptoGestAdminStablecoinBySymbol: '/admin/crypto-gest/stablecoins/${symbol}',
  adminDevelopmentCryptoGestSeed: '/admin/development/crypto-gest-seed',
  adminDevelopmentCryptoGestRollback: '/admin/development/crypto-gest-rollback',
  poolInvestProjects: '/apps/pool-invest/projects',
  poolInvestProjectById: '/apps/pool-invest/projects/${id}',
  poolInvestProjectValuation: '/apps/pool-invest/projects/${projectId}/valuation',
  poolInvestProjectParticipants: '/apps/pool-invest/projects/${projectId}/participants',
  poolInvestProjectParticipantById: '/apps/pool-invest/projects/${projectId}/participants/${id}',
  poolInvestProjectRules: '/apps/pool-invest/projects/${projectId}/rules',
  poolInvestProjectRuleById: '/apps/pool-invest/projects/${projectId}/rules/${id}',
  poolInvestParticipationTimeline: '/apps/pool-invest/projects/${projectId}/participation-timeline',
  poolInvestProjectBuckets: '/apps/pool-invest/projects/${projectId}/buckets',
  poolInvestProjectBucketById: '/apps/pool-invest/projects/${projectId}/buckets/${id}',
  poolInvestProjectEntries: '/apps/pool-invest/projects/${projectId}/entries',
  poolInvestProjectEntryById: '/apps/pool-invest/projects/${projectId}/entries/${id}',
  poolInvestFromCryptoGest: '/apps/pool-invest/projects/${projectId}/entries/from-crypto-gest',
  poolInvestCryptoGestLinks: '/apps/pool-invest/crypto-gest-links',
  poolInvestCryptoGestLinkById: '/apps/pool-invest/crypto-gest-links/${sourceEntryId}',
  cryptoBotConfig: '/apps/crypto-bot/config',
  cryptoBotRun: '/apps/crypto-bot/run',
  cryptoBotOverview: '/apps/crypto-bot/overview',
  cryptoBotBtcCycle: '/apps/crypto-bot/btc-cycle',
  cryptoBotReset: '/apps/crypto-bot/reset',
  cryptoBotRebalances: '/apps/crypto-bot/rebalances',
  cryptoBotExchangeFilters: '/apps/crypto-bot/exchange-filters',
  cryptoBotPositions: '/apps/crypto-bot/positions',
  cryptoBotLogs: '/apps/crypto-bot/logs',
  cryptoBotTestConnection: '/apps/crypto-bot/test-connection',
  cryptoBotImportKeys: '/apps/crypto-bot/import-keys',
  cryptoBotBacktest: '/apps/crypto-bot/backtest',
  cryptoBotBacktestData: '/apps/crypto-bot/backtest-data',
  cryptoBotBacktestDataDownload: '/apps/crypto-bot/backtest-data/download',
  cryptoBotBacktestDataCancel: '/apps/crypto-bot/backtest-data/cancel',
  cryptoBotBacktestDataStatus: '/apps/crypto-bot/backtest-data/status',
  cryptoBotBacktestDataFiles: '/apps/crypto-bot/backtest-data/files',
  cryptoBotBacktestRun: '/apps/crypto-bot/backtest/run',
  cryptoBotBacktestStatus: '/apps/crypto-bot/backtest/status',
  cryptoBotBacktestCancel: '/apps/crypto-bot/backtest/cancel',
  poolInvestFromBank: '/apps/pool-invest/projects/${projectId}/entries/from-bank',
  poolInvestBankLinks: '/apps/pool-invest/bank-links',
  poolInvestBankLinkById: '/apps/pool-invest/bank-links/${sourceEntryId}'
} as const;
